import { SiteUrls } from '@tableau/shared-urls';
import React from 'react';
import { Route } from 'react-router';
import { defaultMemoize } from 'reselect';
import { BreadcrumbStateInfo, SiteUrlsContext } from '../../../data-catalog-shared';
import { createCatalogTablesBreadcrumb } from './BreadcrumbFactories';
import { BreadcrumbsUpdater } from './BreadcrumbsUpdater';

function createTablesBreadcrumbsList(
  urls: SiteUrls,
  urlSuffix: string,
): ReadonlyArray<BreadcrumbStateInfo> {
  return [
    createCatalogTablesBreadcrumb(urls, urlSuffix)
  ];
}

export type TablesBreadcrumbsUpdaterProps = {
};

export class TablesBreadcrumbsUpdater extends React.Component<TablesBreadcrumbsUpdaterProps> {

  private readonly memoizedCreateTablesBreadcrumbsList = defaultMemoize(createTablesBreadcrumbsList);

  public override render() {
    return (
      <SiteUrlsContext.Consumer>
        {urls =>
          <Route>
            {({ location }) => {
              const breadcrumbs = this.memoizedCreateTablesBreadcrumbsList(urls, location.search);
              return (
                <BreadcrumbsUpdater breadcrumbs={breadcrumbs} />
              );
            }}
          </Route>
        }
      </SiteUrlsContext.Consumer>
    );
  }

}
